export default "/images/c09b5df79e85e93b175e85793ad03a3c.avif";